<template>
  <div class="pts-contact">
    <div class="pts-container">
      <h1>{{ $t('where', 'Où sommes-nous ?') }}</h1>
      <object class="map" data="https://maps.google.fr/maps?f=q&amp;source=s_q&amp;hl=fr&amp;geocode=&amp;q=11+Rue+du+Vieux+Ch%C3%A2teau,+Mortcerf&amp;aq=0&amp;oq=11+rue+du+vieux+ch%C3%A2teau+Mortce&amp;sll=48.292406,4.07612&amp;sspn=0.093196,0.264187&amp;t=m&amp;ie=UTF8&amp;hq=&amp;hnear=11+Rue+du+Vieux+Ch%C3%A2teau,+77163+Mortcerf,+Seine-et-Marne,+%C3%8Ele-de-France&amp;z=14&amp;ll=48.783633,2.913169&amp;output=embed" type="text/html" style="width:100%;height:300px">
        <p>La carte ne peut pas s'afficher sur votre navigateur.</p>
      </object>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Contact',

  mounted() {
    this.$polyglot.extendLocales({
      'fr': {
        'where': 'Où sommes-nous ?'
      },
      'en': {
        'where': 'Where are we ?'
      }
    })
  }
}
</script>

<style scoped>
.pts-contact {
  width: 100%;
  background: #F5F5F5;
  padding-top: 5px;
  padding-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Contact.vue